import injectionCode from '../../../preview/advanced-checkout'

const type = 'advanced'
const path = '/advance/angular-node/angular/src/'
const name = 'index.html'

export { path, name, type, injectionCode }
